// 侧边栏显示控制 
// 
<template>
  <div style="padding: 0 15px" @click="toggleClick">
    <img
      class="hamburger"
      src="@/assets/img/hamburger.png"
      :class="{ 'is-active': isActive }"
    />
  </div>
</template>

<script>
export default {
  name: "Hamburger",
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleClick() {
      this.$emit("toggleClick");
    },
  },
};
</script>

<style scoped>
.hamburger {
  display: inline-block;
  vertical-align: middle;
  width: 18px;
  height: 16px;
}
.hamburger.is-active {
  transform: rotate(180deg);
}
</style>


// WEBPACK FOOTER //
// src/components/Hamburger/index.vue